/*
Name: 			Shop5
Written by: 	Okler Themes - (http://www.okler.net)
Theme Version:	5.7.2
*/

(function( $ ) {

	// Mobile menu accordion .find()
	window.mobileMenuButtons = function() {
		$('.mobile-side-menu').on('click', '.mmenu-toggle', function (e) {
			var closestLi = $(this).closest('li');

			if (closestLi.find('ul').length) {
				closestLi.children('ul').slideToggle(300, function () {
					closestLi.toggleClass('open');
				});
				e.preventDefault();
			}
		});
	}
	window.mobileMenuButtons()

	// Mobile menu show/hide
	$('.mmenu-toggle-btn, #mobile-menu-overlay, .mmenu-close-btn').on('click', function (e) {
		$('.body').toggleClass('mmenu-open');
		e.preventDefault();
	});

	// Search Dropdown Toggle
	$('.search-toggle').on('click', function (e) {
		$('.header-search-wrapper').toggleClass('open');
		e.preventDefault();
	});

	// Add logo and cart-dropdown to fixed menu
	// if stick menu is enabled and haven't included yet
	if ( $('#header').data('plugin-options')['stickyEnabled'] &&
		!$('.header-nav').find('.header-logo').length &&
 		!$('.header-nav'). find('.cart-dropdown').length ) {

		var targetArea = $('.header-nav').find('.container');

		// Clone and
		$('.header-logo, .cart-dropdown')
			.clone(true)
			.prependTo(targetArea);
	}

	// Vertical Spinner - Touchspin - Product Details Quantity input
	if ( $.fn.TouchSpin ) {
		$('#product-vqty').TouchSpin({
			verticalbuttons: true
	    });
	}

}).apply( this, [ themejQuery ]);


// WEBPACK FOOTER //
// ./ixcms/themes/src/vendor-js/custom.js